import { render, staticRenderFns } from "./MeetingSummary.vue?vue&type=template&id=b63c2716&scoped=true"
import script from "./MeetingSummary.vue?vue&type=script&lang=js"
export * from "./MeetingSummary.vue?vue&type=script&lang=js"
import style0 from "./MeetingSummary.vue?vue&type=style&index=0&id=b63c2716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63c2716",
  null
  
)

export default component.exports